import { Row, Col } from 'antd'
import { setPriceChanged, setPriceTypeFilter } from '../../../Slices/Kiosk/PriceSlice'
import { renderTranslation, getCurrencySymbolByPricelist } from '../../../Helpers/GenericHelpers'
import { TranslationKeys } from '../../../Constants/TranslationKeys'
import { PriceType } from '../../../Constants/TableConfiguration'
import { VariantModelValue } from '../../../Constants/Configuration'
import { useAppDispatch, useAppSelector } from '../../../hooks'
import InputNumberDiwa from 'Components/Generic/InputNumberDiwa'
import { PriceTypeSave } from 'Helpers/PricesHelper'
import { updateBasePriceValue } from 'Slices/Kiosk/ArticleDetailSlice'

/**
 * @param {any} priceTypeFilter;
 * @param {any} sellAndPurchaseValue;
 */

export default function PricesEditHeader(props) {
  const dispatch = useAppDispatch()
  const language = useAppSelector(state => state.present.language.value)
  const priceList1 = useAppSelector(state => state.present.tableOptions.priceList1)
  return (
    <Col span={props.isBySize ? 24 : 24}>
      <Row className={'omni-prices-table-header'}>
        <Col
          span={props.isBySize ? 8 : 12}
          className={
            !props.isBySize
              ? 'cursor-pointer purchase-button-filter-recap sale' +
                (props.priceTypeFilter.indexOf(PriceType.purchase) !== -1 ? ' active' : '')
              : 'purchase-button-filter-recap-size sale'
          }
          onClick={() => {
            if (props.isBySize) return
            dispatch(setPriceTypeFilter(PriceType.purchase))
          }}
        >
          <span className='purchase-button-text'>
            {renderTranslation(language, TranslationKeys.priceSectionTableFilterACQLabel)}
          </span>

          <span className='purchase-button-price'>
            {props.sellAndPurchaseValue.buyPrice
              ? getCurrencySymbolByPricelist(priceList1, VariantModelValue) + ' '
              : null}

            <InputNumberDiwa
              onClick={e => e.stopPropagation()}
              className={'num-input discount-input'}
              min={0}
              controls={false}
              value={props.sellAndPurchaseValue.buyPrice ? props.sellAndPurchaseValue.buyPrice : null}
              onChange={newprice => {
                const changePayload = {
                  Price: newprice,
                  PriceType: PriceTypeSave.Buy,
                  pricelist: VariantModelValue,
                  SizeId: 0,
                }
                dispatch(setPriceChanged(changePayload))
                dispatch(updateBasePriceValue(changePayload))
              }}
            />
          </span>
        </Col>
        <Col
          span={props.isBySize ? 8 : 12}
          className={
            !props.isBySize
              ? 'cursor-pointer sell-button-filter-recap' +
                (props.priceTypeFilter.indexOf(PriceType.sell) !== -1 ? ' active' : '')
              : 'sell-button-filter-recap-size'
          }
          onClick={() => {
            if (props.isBySize) return
            dispatch(setPriceTypeFilter(PriceType.sell))
          }}
        >
          <span className='sell-button-text'>
            {renderTranslation(language, TranslationKeys.priceSectionTableFilterVENLabel)}
          </span>

          <span className='sell-button-price'>
            {props.sellAndPurchaseValue.sellPrice
              ? getCurrencySymbolByPricelist(priceList1, VariantModelValue) + ' '
              : null}
            <InputNumberDiwa
              onClick={e => e.stopPropagation()}
              className={'num-input discount-input'}
              min={0}
              controls={false}
              value={props.sellAndPurchaseValue.sellPrice ? props.sellAndPurchaseValue.sellPrice : null}
              onChange={newprice => {
                const changePayload = {
                  Price: newprice,
                  PriceType: PriceTypeSave.Sel,
                  pricelist: VariantModelValue,
                  SizeId: 0,
                }
                dispatch(setPriceChanged(changePayload))
                dispatch(updateBasePriceValue(changePayload))
              }}
            />
          </span>
        </Col>
        {props.isBySize ? (
          <Col className={'size-filter-recap'} span={props.isBySize ? 8 : null}>
            <span>{renderTranslation(language, TranslationKeys.priceSectionTableFilterTAGLabel)}</span>
          </Col>
        ) : null}
      </Row>
    </Col>
  )
}
